export default __webpack_public_path__ + "static/media/bulb.3b4dbb46.png";